import {
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import "../index.css";

type ThemeType = "light" | "dark";

interface ThemeInterface {
  theme: ThemeType;
  setTheme: Dispatch<SetStateAction<ThemeType>>;
}

export const ThemeContext = createContext<ThemeInterface>({
  theme: "light",
  setTheme: () => {},
});

const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const getInitialTheme = (): ThemeType => {
    const savedTheme = localStorage.getItem("RingconnectTheme");
    if (savedTheme === "light" || savedTheme === "dark") return savedTheme;

    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    return prefersDark ? "dark" : "light";
  };

  const [theme, setTheme] = useState<ThemeType>(getInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }

    root.setAttribute("data-theme", theme);
    localStorage.setItem("RingconnectTheme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
